export default __webpack_public_path__ + "static/media/j.8f5434c8.mp4";